export default __webpack_public_path__ + "static/media/foo_mascot_chef_hat@2x.f05cbd26.svg";